import React, { Component } from "react";
import "../css/namasankeerthanam.css";

const openingSequence = [
  "Dhyana Slokam",
  "Sangraha Thodaya Mangalam — an opening praise and mangalam",
  "Guru Dhyanam",
  "Guru Abhangs",
  "Sadhu Keertanas — hymns on sadhus and saints",
  "Jayadeva Ashtapadi",
  "Narayana Teertha Krishna Leela Tharangini"
];

const dhyanaKeertanais = [
  "Vinayaka", "Saraswati", "Murugan", "Shiva", "Ambika", "Nrusimha", "Ram", "Krishna", "Vishnu or Dashavatara Stuti", "Venkatesha",
  "Vittal or Pandurang (Abhangs)", "Lakshmi", "Sita or Radha", "Anjaneya", "Garuda", "Aiyappan", "Nandikeshwaran", "Chandeeswaran", "Chaitanya Mahaprabhu", "Sri Gopalakrishna Bhagavatar (or Guru Keertanai)"
];

const poojaKritis = [
  "Baro murare — welcome",
  "Sharanagata vatsala — request",
  "Kastoori gana — pooja",
  "Chita juni — aarati",
  "Shobane",
  "Jay Jay aarati",
  "Kanjadalakshiki",
  "Prartana Abhang",
  "Rajadi rajaya — pushpanjali",
  "Kattiya vachanam — verses from a variety of books",
  "Chatur veda parayan",
  "Kshetra mahatmiyam — verses on the importance of tirtha kshetras",
  "Upacharamu — upachara sankeertan",
  "Vinnappa gadyam — prayers to God",
  "Sri Krishna Govinda hare murare — naamaavali"
];

class Namasankeerthanam extends Component {
  constructor(props) {
    super(props);
    window.clickLog("load", "Namasankeerthanam");
  }

  render() {
    return (
      <article className="nama-page">
        <header className="nama-intro">
          <p className="eyebrow">A devotional tradition</p>
          <h1>Namasankeerthanam</h1>
          <p>Discover the tradition of singing the divine name together: a practice of devotion, music and shared spiritual attention.</p>
        </header>

        <section className="nama-card nama-card--lead">
          <p className="nama-kicker">Bhajan</p>
          <h2>Music offered with bhakti</h2>
          <p>A bhajan or kirtan is a Hindu devotional song, often of ancient origin. Great importance is attributed to singing bhajans with bhakti—loving devotion. “Rasanam Lakshanam Bhajanam” describes the act by which we feel closer to our true self or to God.</p>
          <p><strong>Bhajan</strong> comes from “bhajanam”, meaning to concentrate on the <em>naama</em> or <em>roopa</em> of God. Naama bhajanam—the repetition of the divine name—can be practised throughout the day. When it is uttered with sruti, raaga and thaala, it becomes soothing, draws the mind toward <em>layam</em>, and welcomes the whole gathering into a collective prayer.</p>
        </section>

        <section className="nama-two-column">
          <div className="nama-card">
            <p className="nama-kicker">Many traditions</p>
            <h2>Types of bhajans</h2>
            <p>Bhajans have found a home in the hearts of people across generations. Nirguni, Gorakhanathi, Vallabhapanthi, Ashtachhap and Madhura-bhakti traditions each have their own repertoire and methods of singing.</p>
          </div>
          <div className="nama-card nama-card--accent">
            <p className="nama-kicker">South Indian tradition</p>
            <h2>Sampradaya Bhajans</h2>
            <p>The traditional form of bhajan in South India is known as Sampradaya Bhajans. Its order evolved through Sri Marudhanallur Sadguru Swamigal and Sri Pudukottai Gopala Krishna Bhagavathar.</p>
            <p>The revered guru lineage includes Bodhendra Swamigal, Sridhara Ayyaval and Marudhanallur Sadguru Swamigal.</p>
          </div>
        </section>

        <section className="nama-section" aria-labelledby="sequence-title">
          <div className="nama-section__heading"><p className="nama-kicker">The paddhati</p><h2 id="sequence-title">The flow of a traditional bhajan</h2></div>
          <ol className="nama-timeline">
            {openingSequence.map((item, index) => <li key={item}><span>{String(index + 1).padStart(2, "0")}</span><p>{item === "Jayadeva Ashtapadi" ? <a href="http://en.wikipedia.org/wiki/Jayadeva">{item}</a> : item === "Narayana Teertha Krishna Leela Tharangini" ? <a href="http://en.wikipedia.org/wiki/Narayana_Teertha">{item}</a> : item}</p></li>)}
          </ol>
        </section>

        <section className="nama-card">
          <p className="nama-kicker">A shared repertoire</p>
          <h2>Panchapati</h2>
          <p>Five songs are offered in Telugu (Bhadrachala Ramadas), Kannada (Sri Purandara Dasa), Sanskrit (Sri Sadasiva Brahmendral), Tamil (Sri Gopalakrishna Bharati) and through compositions of Sri Tyagaraja, Kabir Das, Meera Bai, Tulsi Das or Surdas. Marathi abhangs on <a href="http://en.wikipedia.org/wiki/Panduranga">Lord Panduranga</a> also form a cherished part of the repertoire.</p>
        </section>

        <section className="nama-section" aria-labelledby="dhyana-title">
          <div className="nama-section__heading"><p className="nama-kicker">Dhyana Keertanais</p><h2 id="dhyana-title">Hymns offered to the divine</h2></div>
          <div className="nama-grid">
            {dhyanaKeertanais.map((item, index) => <div className="nama-grid__item" key={item}><span>{String(index + 1).padStart(2, "0")}</span>{item}</div>)}
          </div>
        </section>

        <section className="nama-section nama-section--pooja" aria-labelledby="pooja-title">
          <div className="nama-section__heading"><p className="nama-kicker">Pooja Sampradaya Kritis</p><h2 id="pooja-title">A progression of worship</h2></div>
          <ol className="nama-kriti-list">{poojaKritis.map(item => <li key={item}>{item}</li>)}</ol>
        </section>

        <aside className="nama-closing">Pooja concludes and Divya Namam begins: with a lighted lamp at the centre, bhagavatas sing in pradakshina, considering the lamp as God. The gathering continues with dolotsavam, Anjaneya Keerthanai and Mangalam.</aside>
      </article>
    );
  }
}

export default Namasankeerthanam;
